<template>
  <div>
    <page-title title="Collections" :helpLink="{ path: '/pages/station-collector-help', hash: 'AllergenCollectionSet_List' }" />
    <b-row>
      <b-col>
        <filtered-table :settings="tableSettings">
          <template slot="toolbar-buttons">
            <b-button-group class="ml-2">
              <b-button to="/allergenCollectionSet/import"><font-awesome-icon icon="plus"></font-awesome-icon> Bulk Upload</b-button>
            </b-button-group>
          </template>
        </filtered-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "AllergenCollectionSetList",
  props: {},
  data() {
    let base = this;
    return {
      tableSettings: {
        query: 'allergenCollectionSets',
        newUrl: '/allergenCollectionSet/add',
        defaultSortColumn: 'date',
        defaultSortOrder: 'desc',
        columns: [
          {
            key: 'id',
            name: 'ID',
            alwaysLoad: true,
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'date',
            name: 'Date',
            visible: true,
            sortable: true,
            filter: 'daterange'
          },
          {
            key: 'station.name',
            name: 'Station Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'station.city',
            name: 'Station City',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'station.state',
            name: 'Station State',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'comment',
            name: 'Comment',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'weatherNotes',
            name: 'Weather Notes',
            visible: false,
            sortable: true,
            filter: 'text'
          }
        ],
        rowClicked: function (item, context) {
          context.$router.push('/allergenCollectionSet/' + item.id)
        }
      }
    }
  },
  methods: {
  },
  mounted () {
  }
};
</script>